import React from 'react'

const Footer=()=>{
    return(
        <div className="footer row">
            <p className="col-md-6" style={{color:'black'}}>Hope you guys having fun. For any query or feedback contact here.</p>
            <p className='email' className="col-md-6" style={{color:'black'}}>Contact Me: underratedgames22@gmail.com</p>
        </div>
    )
}

export default Footer